(() => {
  if (window.__zetaRankingInitialized) {
    return;
  }
  window.__zetaRankingInitialized = true;

  const ROOT_SELECTOR = '[data-zeta-ranking]';
  const INITIALIZED_ATTRIBUTE = 'data-zeta-ranking-initialized';
  const DEFAULT_PRODUCTS_COUNT = 10;
  const FETCH_LIMIT = 50; // カラー展開ぶんを見込んだ1回あたりの取得件数
  const MAX_FETCH_ROUNDS = 2; // ユニーク件数が不足した場合の追加取得は1回まで
  const POPULARITY_SORT = '-popularity';
  const INCLUDE_SOLD_OUT = 0;

  function buildCard(root, item, rankingNumber) {
    const template = root.querySelector('[data-zeta-ranking-card-template]');
    const node = template.content.cloneNode(true);
    const imageLink = node.querySelector('[data-zeta-ranking-link]');
    const bodyLink = node.querySelector('[data-zeta-ranking-body-link]');
    const image = node.querySelector('[data-zeta-ranking-image]');
    const ranking = node.querySelector('[data-zeta-ranking-number]');
    const title = node.querySelector('[data-zeta-ranking-title]');
    const price = node.querySelector('[data-zeta-ranking-price]');
    const compare = node.querySelector('[data-zeta-ranking-compare]');
    const wishlistSlot = node.querySelector('[data-zeta-wishlist-slot]');

    imageLink.href = item.url;
    bodyLink.href = item.url;
    ranking.textContent = String(rankingNumber);
    ranking.setAttribute('aria-label', `ランキング ${rankingNumber}位`);
    title.textContent = item.title;
    const discountedPrice = window.Anatai?.getDiscountedPrice(item.price) ?? null;
    if (discountedPrice !== null) {
      price.textContent = window.Zeta.formatMoney(discountedPrice);
      price.classList.add('c-product-card__price-sale');
      compare.textContent = window.Zeta.formatMoney(item.price);
      compare.hidden = false;
    } else {
      price.textContent = window.Zeta.formatMoney(item.price);
    }

    if (item.imageUrl) {
      image.src = item.imageUrl;
      image.alt = item.colorName ? `${item.title} ${item.colorName}` : item.title;
    }
    if (discountedPrice === null && item.onSale) {
      price.classList.add('c-product-card__price-sale');
    }
    if (discountedPrice === null && item.compareAtPrice != null) {
      compare.textContent = window.Zeta.formatMoney(item.compareAtPrice);
      compare.hidden = false;
    }

    if (wishlistSlot) {
      wishlistSlot.dataset.zetaItemId = item.id;
      wishlistSlot.dataset.zetaSku = item.sku;
      wishlistSlot.dataset.zetaColorCode = item.colorCode;
      wishlistSlot.dataset.zetaColorName = item.colorName;
      wishlistSlot.dataset.zetaSoldOut = item.soldOut ? '1' : '0';
    }

    return node;
  }

  function syncGallery(root) {
    const gallery = root.querySelector('[data-zeta-ranking-gallery]');
    const scroller = root.querySelector('[data-zeta-ranking-scroller]');
    gallery.connectedCallback();
    window.requestAnimationFrame(() => {
      scroller._checkScrollability();
      window.dispatchEvent(new Event('resize'));
    });
  }

  function hideSection(root) {
    const section = root.closest('.shopify-section');
    (section || root).hidden = true;
  }

  function showEmptyState(root) {
    const empty = root.querySelector('[data-zeta-ranking-empty]');
    if (!empty) {
      hideSection(root);
      return;
    }

    empty.hidden = false;

    const scroller = root.querySelector('[data-zeta-ranking-scroller]');
    if (scroller) {
      scroller.hidden = true;
    }

    const controls = root.querySelector('.gallery__prev-next-buttons');
    if (controls) {
      controls.hidden = true;
    }

    const progress = root.querySelector('.c-featured-collections__progress-wrapper');
    if (progress) {
      progress.hidden = true;
    }
  }

  async function fetchRankingItems(productsCount, category) {
    const representativeItems = new Map();
    const itemIds = [];

    for (let round = 0; round < MAX_FETCH_ROUNDS; round += 1) {
      const params = {
        q: '',
        l: FETCH_LIMIT,
        o: round * FETCH_LIMIT,
        s: POPULARITY_SORT,
        stock: INCLUDE_SOLD_OUT,
      };
      if (category) {
        params.filters = { category: [category] };
      }

      const result = await window.Zeta.fetchItems(params);
      const items = Array.isArray(result.items) ? result.items : [];

      items.forEach((item) => {
        if (!item.id) {
          return;
        }

        const representativeItem = representativeItems.get(item.id);
        if (!representativeItem) {
          representativeItems.set(item.id, item);
          itemIds.push(item.id);
          return;
        }

        // 商品のカラー並びで先頭の色を代表にする。
        if (
          item.colorPosition != null &&
          (representativeItem.colorPosition == null || item.colorPosition < representativeItem.colorPosition)
        ) {
          representativeItems.set(item.id, item);
        }
      });

      // 最後に追加した商品の全カラーを比較するため、ラウンド内は最後まで走査してから判定する。
      if (itemIds.length >= productsCount || items.length < FETCH_LIMIT) {
        break;
      }
    }

    return itemIds.map((itemId) => representativeItems.get(itemId)).slice(0, productsCount);
  }

  async function initializeRanking(root) {
    if (root.hasAttribute(INITIALIZED_ATTRIBUTE)) {
      return;
    }
    root.setAttribute(INITIALIZED_ATTRIBUTE, '');

    const list = root.querySelector('[data-zeta-ranking-list]');
    const productsCount = parseInt(root.dataset.productsCount, 10) || DEFAULT_PRODUCTS_COUNT;
    const category = root.dataset.zetaRankingCategory || '';

    try {
      const items = await fetchRankingItems(productsCount, category);

      if (items.length === 0) {
        showEmptyState(root);
        return;
      }

      const fragment = document.createDocumentFragment();
      items.forEach((item, index) => {
        fragment.appendChild(buildCard(root, item, index + 1));
      });
      list.appendChild(fragment);

      await window.Zeta.hydrateProductCards(list, {
        className: 'c-product-card__wishlist',
        soldSelector: '[data-zeta-ranking-sold]',
        imageSelector: '[data-zeta-ranking-image]',
        hoverImageSelector: '[data-zeta-ranking-image-hover]',
      });

      const progressBar = root.querySelector('.gallery__progress-bar');
      if (progressBar) {
        progressBar.style.setProperty('--divider', String(items.length));
      }

      syncGallery(root);
    } catch (error) {
      console.error('[ZETA Ranking]', error);
      hideSection(root);
    }
  }

  function initializeRankings() {
    if (!window.Zeta) {
      document.querySelectorAll(ROOT_SELECTOR).forEach((root) => hideSection(root));
      return;
    }
    document.querySelectorAll(ROOT_SELECTOR).forEach((root) => initializeRanking(root));
  }

  initializeRankings();
  document.addEventListener('shopify:section:load', initializeRankings);
})();
